export enum FormMessagesEnum {
  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
  DATE_BEFORE = 'DATE_BEFORE',
  EMPTY = 'EMPTY',
  MAX_APPOINTMENTS = 'MAX_APPOINTMENTS',
  PASSWORD = 'PASSWORD',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  REQUIRED = 'REQUIRED',
  TERMS = 'TERMS',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_TYPE = 'WRONG_TYPE',
}
